export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-10">
          关于我们
        </h2>
        <div className="max-w-3xl mx-auto text-center">
          <p className="text-foreground-700 text-base md:text-lg leading-relaxed mb-6">
            老子影视网是一个专注于<strong>电视剧大全全集播放</strong>的在线平台，
            致力于为广大观众提供<strong>国产剧全集</strong>、<strong>韩剧全集</strong>
            以及<strong>最新电视剧</strong>的免费在线观看服务。
            我们以<strong>高清画质</strong>和<strong>流畅不缓冲</strong>的播放体验为核心，
            每日同步更新热播剧集，覆盖悬疑、言情、古装、都市、奇幻等多元类型，
            让每一位追剧爱好者都能在这里找到心仪的内容。
          </p>
          <p className="text-foreground-600 text-sm leading-relaxed">
            平台自上线以来，始终坚持以用户体验为中心，不断优化播放技术和内容覆盖范围，
            力求成为您最信赖的<strong>电视剧在线</strong>观看首选平台。
          </p>
        </div>
      </div>
    </section>
  );
}